import { useMemo } from "react";
import { useIsMasterCompany } from "../../../utils/hooks/company";

export const useDrawerProps = ({ mode, help, view, create, transfer, edit, clone, clockInSettings = false }) => {
	const isMaster = useIsMasterCompany();

	const open = useMemo(() => {
		return mode !== "view";
	}, [mode]);

	const title = useMemo(() => {
		switch (mode) {
			case "help":
				return help;
			case "clone":
				return clone;
			case "edit":
				return (isMaster || clockInSettings) ? edit : view;
			case "create":
				return create;
			case "transfer":
				return transfer
			default:
				return null;
		}
	}, [mode, help, clone, isMaster, edit, view, create, transfer, clockInSettings]);

	return { title, open };
};
